import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainUnBind(card) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/unBind/${card}`,
    method: "post",
  });
}
